import Http from '@/api/http.js'

export default {
  index(params) {
    return Http.get(`/client_orders_histories`, { params })
  },
}